module.exports = __webpack_public_path__ + "images/emoji_5_color93bb13f6006183dff91e607a984ce52e.svg";